import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
interface PreviewCaseSectionProps {
  readonly title: string;
  readonly description?: string;
  readonly children: ReactNode;
}
export function PreviewCaseSection(t0) {
  const $ = _c(8);
  const {
    title,
    description,
    children
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h5 className="tw-mb-0 tw-text-sm tw-font-semibold tw-text-iron-200">{title}</h5>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = description && <p className="tw-mb-0 tw-text-xs tw-text-iron-400">{description}</p>;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t1 || $[6] !== t2) {
    t3 = <section className="tw-space-y-3">{t1}{t2}{children}</section>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}